// Build a clean plain-text preview from article markdown for truncated
// card/list snippets. Drops images and link URLs (keeping the link's visible
// text) so a mid-URL truncation can't produce broken markdown, and removes
// stray formatting so the snippet stays tidy no matter where it's cut.
export const stripImages = (text = "") =>
  text
    .replace(/!\[[^\]]*\]\([^)]*\)/g, "") // images
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1") // links -> visible text only
    .replace(/^\s*[-*_]{3,}\s*$/gm, "") // horizontal rules
    .replace(/[*_`>#]/g, "") // stray bold/italic/code/quote/heading marks
    .replace(/\n{3,}/g, "\n\n")
    .replace(/^\s+/, "")
